
class CapStartRoutePullEntry {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'start_route_pull_entry'
}

function create(config) {
  return new CapStartRoutePullEntry(config)
}

export default {
  key,
  create,
}
